import RedeemCodesList from "../components/RedeemCodesList"
import { FC } from "react"

const RedeemCodesPage: FC = () => {
  return (
    <>
      <RedeemCodesList />
    </>
  )
}

export default RedeemCodesPage